import './index.less'
import React, { FC } from 'react'
import { useSelector } from "react-redux";

import { TStoreData, TTrackingData } from '@/interface';


interface TProps {
	trackingData: TTrackingData;
	bodyStyle?: any;
	itemStyle?: any;
}

const ViewsCard: FC<TProps> = (props: TProps) => {
	const { bodyStyle, itemStyle } = props;

	const storeData = useSelector((data: TStoreData) => {
        return {
			trackingData: data?.eventTracking
        };
    });
    const { trackingData } = storeData;

	return (
		<div className="jx-views-card" style={bodyStyle}>
			<div className="jx-views-card-content">
				<div className="jx-views-card-item" style={itemStyle}>
					<div className="jx-views-card-item-title">C业务线总览</div>
					<div className="jx-views-card-item-number">{trackingData.c_total ? trackingData.c_total : '-'}/{trackingData.c_other ? trackingData.c_other : '-'}</div>
					<div className="jx-views-card-item-compare">共计/三方</div>
				</div>
				<div className="jx-views-card-item" style={itemStyle}>
					<div className="jx-views-card-item-title">C业务线BD</div>
					<div className="jx-views-card-item-number">{trackingData.c_bd ? trackingData.c_bd : '-'}</div>
					<div className="jx-views-card-item-compare">BD</div>
				</div>
				<div className="jx-views-card-item" style={itemStyle}>
					<div className="jx-views-card-item-title">C业务线BDM/CM</div>
					<div className="jx-views-card-item-number">{trackingData.c_bdm ? trackingData.c_bdm : '-'}/{trackingData.c_cm ? trackingData.c_cm : '-'}</div>
					<div className="jx-views-card-item-compare">BDM/CM</div>
				</div>
				{/*<div className="jx-views-card-item" style={itemStyle}>*/}
				{/*	<div className="jx-views-card-item-title">B业务线总览</div>*/}
				{/*	<div className="jx-views-card-item-number">{trackingData.b_total || '--'}</div>*/}
				{/*	<div className="jx-views-card-item-compare">总计</div>*/}
				{/*</div>*/}
			</div>

		</div>
	)
}

export default ViewsCard
